import React from 'react';
import { Descriptions } from 'antd';
import StatusTag from '../../../components/ui/StatusTag';
import { PurchaseOrderInfo } from '../../../types/PurchaseOrder';

interface PurchaseOrderInfoViewProps {
  purchaseOrderInfo: PurchaseOrderInfo | undefined;
}
const PurchaseOrderInfoView: React.FC<PurchaseOrderInfoViewProps> = ({
  purchaseOrderInfo,
}) => {
  return (
    <>
      <Descriptions
        title="Purchase Order"
        style={{
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: '0.25rem',
        }}
      >
        <Descriptions.Item label="Code">
          {purchaseOrderInfo?.code}
        </Descriptions.Item>
        <Descriptions.Item label="Order Date">
          {purchaseOrderInfo?.orderDate}
        </Descriptions.Item>
        <Descriptions.Item label="Required Date">
          {purchaseOrderInfo?.requiredDate}
        </Descriptions.Item>
        <Descriptions.Item label="Vendor">
          {purchaseOrderInfo?.vendor?.description}
        </Descriptions.Item>
        <Descriptions.Item label="Destination" span={2}>
          {purchaseOrderInfo?.destination?.description}
        </Descriptions.Item>
        <Descriptions.Item label="Currency">
          {purchaseOrderInfo?.currency === undefined ||
          purchaseOrderInfo?.currency === null
            ? ''
            : purchaseOrderInfo?.currency}
        </Descriptions.Item>
        <Descriptions.Item label="Terms" span={2}>
          {purchaseOrderInfo?.terms?.description}
        </Descriptions.Item>
        <Descriptions.Item label="Source Document">
          {purchaseOrderInfo?.source}
        </Descriptions.Item>
        <Descriptions.Item label="Notes" span={2}>
          {purchaseOrderInfo?.notes}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag status={purchaseOrderInfo?.status ?? ''} />
        </Descriptions.Item>
        {purchaseOrderInfo?.status === 'APPROVED' ? (
          // ||
          // purchaseOrderInfo?.status === 'READY' ||
          // purchaseOrderInfo?.status === 'DONE'
          <>
            <Descriptions.Item label="Approved By">
              {purchaseOrderInfo?.approvedBy}
            </Descriptions.Item>
            <Descriptions.Item label="Approved Date">
              {purchaseOrderInfo?.approvedDate}
            </Descriptions.Item>
          </>
        ) : null}
      </Descriptions>
    </>
  );
};

export default PurchaseOrderInfoView;
